
export const HOME = "/"
export const SEARCH = "/search"
export const LISTING = "search/listing/:id"
export const EMI = "/emi-calculator"
export const ADD = "/add"
export const BLOG = '/blog/:id'
export const MAINBLOG = '/blog'
export const BLOGADD = '/blog/add'
export const LOGIN = '/login'
export const CONTACT = '/contact'
export const ABOUT = '/about'